import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DummyService {
  constructor() {}

  titleSettingDialogDummy(){
    const res = [
        [
            {
                "kbnTag": "#ユーザー区分1",
                "ttlLst": [
                    {
                        "ttlName": "#食事",
                        "ttlNameLst": [
                            {
                                "ttlItemName": "同じ区分ID・IDテスト最新"
                            },
                            {
                                "ttlItemName": "同じ区分ID・IDテスト最新1"
                            }
                        ],
                        "iTagLst": [
                            {
                                "iTag": "#主食#",
                                "iTagNameLst": [
                                    {
                                        "iTagName": "主食_最新"
                                    },
                                    {
                                        "iTagName": "主食_最新1"
                                    }
                                ]
                            },
                            {
                                "iTag": "#副食",
                                "iTagNameLst": [
                                    {
                                        "iTagName": "副食"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    ]
    return res;
  }

  answerDialogDummy(){
    return [
        { answerName: "#実施"},
        { answerName: "#中止"}
    ]
  }
  
}
